import * as algoliaStyles from '../styles/communs/algolia.module.scss';

import React from 'react';
import PropTypes from 'prop-types';
import HitColumns from './HitColumns';
import { useTranslation } from 'react-i18next';

const sortingOptions = {
  'default': ['internalpage', 'people', 'event', 'news', 'exedproduct'],
  'chercheur': ['internalpage', 'people', 'event', 'news', 'exedproduct'],
  'exedproduct': ['exedproduct', 'internalpage', 'news', 'event']
};

const AlgoliaResults = ({websiteRoot, language, searchWord, results }) => {
  const { t } = useTranslation();
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  let sortBy = 'default';
  if (currentUrl.includes('executive-education')) {
    sortBy = 'exedproduct';
  }
  return (
    <div className={algoliaStyles.container}>
      {results && results.length > 0 && (
        <>
          {(sortingOptions[sortBy] || sortingOptions.default).map((type) => {
            const result = results.find(r => r.type === type);
            if (!result || !result.hits || result.hits.length === 0)
              return null;
            return (
              <div
                className={algoliaStyles.columns}
                key={result.type}
              >
                <HitColumns
                  hits={result.hits}
                  language={language}
                  searchWords={searchWord}
                  seeMore
                  title={t(`search.${result.type}`)}
                  type={result.type}
                  websiteRoot={websiteRoot}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

AlgoliaResults.propTypes = {
  language: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    hits: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      title: PropTypes.string,
      website: PropTypes.string,
    })).isRequired,
  })).isRequired,
  searchWord: PropTypes.string.isRequired,
  sortBy: PropTypes.string,
  websiteRoot: PropTypes.string.isRequired,
};

export default AlgoliaResults;
